// libs
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Chip, Tabs } from '@mui/material';

// styles
import styles from './styles';

export interface LibFilterChipsArrayProps {
  chipDataArray: {
    key: string;
    label: string;
  }[];
  handleDeleteFilterChip?: (key: string) => void;
}

function LibFilterChipsArray({
  chipDataArray,
  handleDeleteFilterChip
}: LibFilterChipsArrayProps) {
  return (
    <Box sx={styles.mainContainer}>
      <Tabs
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        value={false}
      >
        {chipDataArray.map((data) => (
          <Chip
            sx={styles.chipList}
            key={data.key}
            label={data.label}
            onDelete={() => handleDeleteFilterChip(data.key)}
            deleteIcon={<CloseIcon sx={styles.closeIcon} />}
            role="tab"
          />
        ))}
      </Tabs>
    </Box>
  );
}

export const FilterChipsArray = React.memo(LibFilterChipsArray);
